export default __webpack_public_path__ + "static/media/rocket-color.f4dbf556.svg";